module.exports = __webpack_public_path__ + "static/img/scene-zzj.32f95ea.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/scene/scene-zzj.png
// module id = HX8+
// module chunks = 1